import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['menu', 'arrow'];

  declare readonly menuTarget: HTMLElement;
  declare readonly arrowTarget: HTMLElement;

  private clickOutsideListener!: (event: MouseEvent) => void;
  private keyDownListener!: (event: KeyboardEvent) => void;

  connect(): void {
    this.clickOutsideListener = (event: MouseEvent) =>
      this.handleClickOutside(event);
    this.keyDownListener = (event: KeyboardEvent) => this.handleKeyDown(event);
  }

  disconnect(): void {
    this.removeGlobalListeners();
  }

  toggle(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.isOpen() ? this.close() : this.open();
  }

  open(): void {
    this.menuTarget.classList.add('open');
    this.arrowTarget.classList.add('open-up');

    document.addEventListener('click', this.clickOutsideListener);
    document.addEventListener('keydown', this.keyDownListener);
  }

  close(): void {
    this.menuTarget.classList.remove('open');
    this.arrowTarget.classList.remove('open-up');

    this.removeGlobalListeners();
  }

  private isOpen(): boolean {
    return this.menuTarget.classList.contains('open');
  }

  private handleClickOutside(event: MouseEvent): void {
    if (!this.element.contains(event.target as Node)) {
      this.close();
    }
  }

  private handleKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Escape') {
      this.close();
    }
  }

  private removeGlobalListeners(): void {
    document.removeEventListener('click', this.clickOutsideListener);
    document.removeEventListener('keydown', this.keyDownListener);
  }
}
